import { useEffect, useState, useRef } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../utils/firebase/firebase.utils';

const useSurveysProgress = (userId, surveyIds, setSurveyIds) => {
  const [surveysProgress, setSurveysProgress] = useState({});
  // Use a ref to keep track of active subscriptions to avoid duplicates
  const activeSubscriptions = useRef({});

  useEffect(() => {
    surveyIds.forEach(surveyId => {
      // Check if we are already subscribing to changes for this surveyId
      if (activeSubscriptions.current[surveyId]) {
        return;
      }

      const surveyDocRef = doc(db, 'users', userId, 'dashboardRunProgress', surveyId);

      const unsubscribe = onSnapshot(surveyDocRef, (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          const newProgress = data.percentageCompleted;
          setSurveysProgress(prevProgress => ({
            ...prevProgress,
            [surveyId]: Math.min(newProgress, 100)
          }));

          // If survey is completed, remove its subscription and surveyId
          if (newProgress >= 100) {
            // Cleanup this subscription
            unsubscribe();
            // Remove from active subscriptions
            delete activeSubscriptions.current[surveyId];
            // Update parent component's surveyIds state to exclude the completed survey
            setSurveyIds(prevIds => prevIds.filter(id => id !== surveyId));
          }
        } else {
          console.log(`No document for surveyId: ${surveyId}`);
        }
      });

      // Mark this surveyId as subscribed
      activeSubscriptions.current[surveyId] = true;
      
      // Return cleanup function
      return () => {
        unsubscribe();
        delete activeSubscriptions.current[surveyId];
      };
    });
  }, [userId, surveyIds, setSurveyIds]); // Include setSurveyIds as a dependency if it could change

  return surveysProgress;
};

export default useSurveysProgress;